<template>
<div id="app" class="page">
  <!-- <router-view name="sidebar" class="sidebar-menu" :style="{width: this.$store.getters.getShrink?'60px':'200px', overflow: this.$store.getters.getShrink ? 'visible' : 'auto'}"></router-view> -->
  <router-view name="header" class="main-header" :style="headerStyle"></router-view>
  <router-view name="main" class="main-container" :style="headerStyle"></router-view>
</div>
</template>

<script>
export default {
  name: 'app',
  data: function () {
    return {
      shrink: this.$store.getters.getShrink
    }
  },
  computed: {
    headerStyle: function () {
      // const padding = this.$store.getters.getShrink ? '60px' : '200px'
      // const routers = ['dashboard', 'study', 'patient']
      // const isMain = routers.indexOf(this.$route.name)
      return {
        left: 0
      }
    }
  }
}
</script>
